<div class="auth-callback">
  <app-tenant-logo
    [useMasterLogo]="true"
    class="auth-callback__tenant-logo"
  ></app-tenant-logo>
  <div class="auth-callback__spinner-wrap">
    <svg
      class="auth-callback__spinner"
      viewBox="0 0 56 56"
      fill="none"
      aria-hidden="true"
    >
      <circle
        class="auth-callback__track"
        cx="28"
        cy="28"
        r="24"
      />
      <circle
        class="auth-callback__arc"
        cx="28"
        cy="28"
        r="24"
      />
    </svg>
    <div class="auth-callback__lock">
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect
          x="5"
          y="11"
          width="14"
          height="10"
          rx="2"
        />
        <path
          class="auth-callback__shackle"
          d="M8 11V7a4 4 0 0 1 8 0v4"
        />
      </svg>
    </div>
  </div>
  <h1 class="auth-callback__title">{{ 'authentication.sso_callback_title' | translate }}</h1>
</div>
